const hardforkChanges = [
  [ 'chainstart', require('./chainstart.json') ],
  [ 'homestead', require('./homestead.json') ],
  [ 'dao', require('./dao.json') ],
  [ 'tangerineWhistle', require('./tangerineWhistle.json') ],
  [ 'spuriousDragon', require('./spuriousDragon.json') ],
  [ 'byzantium', require('./byzantium.json') ],
  [ 'constantinople', require('./constantinople.json') ],
  [ 'hybridCasper', require('./hybridCasper.json') ]
]

module.exports = hardforkChanges



//////////////////
// WEBPACK FOOTER
// ./~/ganache-core/~/ethereumjs-common/hardforks/index.js
// module id = 1367
// module chunks = 0 1 2